var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{staticClass:"text_table",on:{"tab-click":_vm.tabClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"机能设备","name":"1"}}),_c('el-tab-pane',{attrs:{"label":"体能设备","name":"2"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }